import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

import "./dizajnvolana.css";
import LoaderVolan from "../components/LoaderVolan";



emailjs.init({ publicKey: "KML-P95O0jZPSRfqn" });

export default function DizajnVolana() {
  const [materials, setMaterials] = useState([]);
  const [pageData, setPageData] = useState({});

  const [topMaterial, setTopMaterial] = useState("");
  const [sideMaterial, setSideMaterial] = useState("");
  const [stitchColor, setStitchColor] = useState("");
  const [ringColor, setRingColor] = useState("");
  const [airbag, setAirbag] = useState("");
  const [wheelModel, setWheelModel] = useState("");
  const [carModel, setCarModel] = useState("");
  const [buttons, setButtons] = useState("");
  const [f1, setF1] = useState("");
  const [modification, setModification] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    fetch("https://carboncro.hr/wp-json/wp/v2/pages?slug=dizajn-volana")
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) setPageData(data[0].acf);
      })
      .catch((err) => console.error("Greška pri dohvatu stranice:", err));
  }, []);

  useEffect(() => {
    fetch("https://carboncro.hr/wp-json/wp/v2/materijali")
      .then((res) => res.json())
      .then(async (data) => {
        const parsed = await Promise.all(
          data.map(async (item) => {
            let slika = "";
            if (item.featured_media) {
              const mediaRes = await fetch(
                `https://carboncro.hr/wp-json/wp/v2/media/${item.featured_media}`
              );
              const mediaData = await mediaRes.json();
              slika = mediaData.source_url || "";
            }
            return { id: item.id, naziv: item.title.rendered, slika };
          })
        );
        setMaterials(parsed);
      })
      .catch((err) => console.error("Greška pri dohvatu materijala:", err));
  }, []);

  const parseOpcije = (str) => {
    if (!str) return [];
    return str.split(/[\r\n,]+/).map((s) => s.trim()).filter(Boolean);
  };

  const opcijeStav = parseOpcije(pageData.opcije_sav);
  const opcijePrsten = parseOpcije(pageData.opcije_prstena);

  // Dozvoljava samo znamenke i po jedan "+" na početku (za pozivni broj, npr. +385...)
  const handlePhoneChange = (e) => {
    let value = e.target.value;

    const imaPlus = value.startsWith("+");
    let samoZnamenke = value.replace(/\D/g, ""); // makni sve što nije znamenka
    samoZnamenke = samoZnamenke.slice(0, 15); // razuman max broj znamenki

    const noviBroj = (imaPlus ? "+" : "") + samoZnamenke;

    setPhone(noviBroj);

    if (phoneError) setPhoneError("");
  };

  // Provjera ispravnosti broja: 8–15 znamenki, opcionalno s "+" na početku
  const isPhoneValid = (value) => /^\+?\d{8,15}$/.test(value);

  const handlePhoneBlur = () => {
    if (phone && !isPhoneValid(phone)) {
      setPhoneError("Unesi ispravan broj telefona (npr. 0912345678 ili +385912345678).");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isPhoneValid(phone)) {
      setPhoneError("Unesi ispravan broj telefona (npr. 0912345678 ili +385912345678).");
      return;
    }

    const details = `Gornji materijal: ${topMaterial || "—"}
Materijal bokova: ${sideMaterial || "—"}
Šav: ${stitchColor || "—"}
Prsten: ${ringColor || "—"}
Airbag: ${airbag || "—"}
Model volana: ${wheelModel || "—"}
Auto: ${carModel || "—"}
Tipke: ${buttons || "—"}
F1 shifteri: ${f1 || "—"}
Modifikacija: ${modification || "—"}
Telefon: ${phone || "—"}
Napomena: ${note || "—"}`;

    const templateParams = {
      name,
      email,
      phone,
      subject: "Upit — Dizajn volana",
      details,
    };

    try {
      await emailjs.send("service_e1fywjb", "template_ypv0dyy", templateParams);

      alert("Upit uspješno poslan!");

      setTopMaterial("");
      setSideMaterial("");
      setStitchColor("");
      setRingColor("");
      setAirbag("");
      setWheelModel("");
      setCarModel("");
      setButtons("");
      setF1("");
      setModification("");
      setName("");
      setEmail("");
      setPhone("");
      setPhoneError("");
      setNote("");
    } catch (error) {
      console.error("Greška:", error);
      alert("Greška pri slanju.");
    }
  };

  return (
    <div className="volan-container">
      <h1>{pageData.naslov || "Dizajniraj svoj volan"}</h1>

      <h2>{pageData.naslov_materijal || "Gornji materijal"}</h2>
      {materials.length === 0 ? (
        <LoaderVolan />
      ) : (
        <div className="material-grid">
          {materials.map((m) => (
            <div
              key={`top-${m.id}`}
              onClick={() => setTopMaterial(m.naziv)}
              className={topMaterial === m.naziv ? "active" : ""}
            >
              {m.slika && <img src={m.slika} alt={m.naziv} />}
              <p>{m.naziv}</p>
            </div>
          ))}
        </div>
      )}

      <h2>{pageData.naslov_materijal_bokovi || "Materijal bokova"}</h2>
      {materials.length === 0 ? (
        <LoaderVolan />
      ) : (
        <div className="material-grid">
          {materials.map((m) => (
            <div
              key={`side-${m.id}`}
              onClick={() => setSideMaterial(m.naziv)}
              className={sideMaterial === m.naziv ? "active" : ""}
            >
              {m.slika && <img src={m.slika} alt={m.naziv} />}
              <p>{m.naziv}</p>
            </div>
          ))}
        </div>
      )}

      <h2>{pageData.naslov_sav || "Šav"}</h2>
      <select value={stitchColor} onChange={(e) => setStitchColor(e.target.value)}>
        <option value="">Odaberi</option>
        {opcijeStav.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>

      <h2>{pageData.naslov_prsten || "Prsten"}</h2>
      <select value={ringColor} onChange={(e) => setRingColor(e.target.value)}>
        <option value="">Odaberi</option>
        {opcijePrsten.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>

      <div className="radio-group">
        <h2>{pageData.naslov_airbag || "Presvlačenje airbaga"}</h2>
        <label>
          <input type="radio" name="airbag" value="Da" checked={airbag === "Da"} onChange={(e) => setAirbag(e.target.value)} />
          Da
        </label>
        <label>
          <input type="radio" name="airbag" value="Ne" checked={airbag === "Ne"} onChange={(e) => setAirbag(e.target.value)} />
          Ne
        </label>
      </div>

      <h2>{pageData.naslov_info || "Informacije o volanu"}</h2>
      <input type="text" placeholder="Model volana npr. OEM Trokraki, Flatbottom..." value={wheelModel} onChange={(e) => setWheelModel(e.target.value)} />
      <input type="text" placeholder="Iz kojeg auta npr. BMW M3, Audi RS4..." value={carModel} onChange={(e) => setCarModel(e.target.value)} />

      <div className="select-group">
        <select value={buttons} onChange={(e) => setButtons(e.target.value)}>
          <option value="">Ima tipke?</option>
          <option value="Da">Da</option>
          <option value="Ne">Ne</option>
        </select>
      </div>

      <div className="select-group">
        <select value={f1} onChange={(e) => setF1(e.target.value)}>
          <option value="">Ima li F1 shiftere?</option>
          <option value="Da">Da</option>
          <option value="Ne">Ne</option>
        </select>
      </div>

      <div className="radio-group">
        <h3>Oblikovanje volana (modifikacija)?</h3>
        <label>
          <input type="radio" name="modification" value="Da" checked={modification === "Da"} onChange={(e) => setModification(e.target.value)} />
          Da
        </label>
        <label>
          <input type="radio" name="modification" value="Ne" checked={modification === "Ne"} onChange={(e) => setModification(e.target.value)} />
          Ne
        </label>
      </div>

      <div className="summary">
        <h3>Tvoj odabir:</h3>
        <p>Gornji materijal: {topMaterial || "—"}</p>
        <p>Materijal bokova: {sideMaterial || "—"}</p>
        <p>Šav: {stitchColor || "—"}</p>
        <p>Prsten: {ringColor || "—"}</p>
        <p>Airbag: {airbag || "—"}</p>
        <p>Volan: {wheelModel || "—"}</p>
        <p>Auto: {carModel || "—"}</p>
        <p>Tipke: {buttons || "—"}</p>
        <p>F1: {f1 || "—"}</p>
        <p>Modifikacija: {modification || "—"}</p>
        <p>Telefon: {phone || "—"}</p>
      </div>

      <h2>{pageData.naslov_kontakt || "Kontakt"}</h2>
      <form onSubmit={handleSubmit} className="form">
        <input type="text" placeholder={pageData.placeholder_ime || "Ime i prezime"} value={name} onChange={(e) => setName(e.target.value)} required />
        <input type="email" placeholder={pageData.placeholder_email || "Email"} value={email} onChange={(e) => setEmail(e.target.value)} required />

        <input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          name="kontakt-broj"
          placeholder="Broj telefona (npr. 0912345678)"
          value={phone}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          pattern="^\+?\d{8,15}$"
          title="Unesi samo brojeve, po potrebi s + na početku (8-15 znamenki)"
          required
        />
        {phoneError && <p className="field-error">{phoneError}</p>}

        <textarea placeholder={pageData.placeholder_napomena || "Dodatne želje..."} value={note} onChange={(e) => setNote(e.target.value)} />
        <button type="submit" className="btn">{pageData.tekst_gumba || "Pošalji upit"}</button>
      </form>
    </div>
  );
}